<template>
    <div class="workflows__list_table">
        <component-table
            :labels="tableLabels"
            :items="items"
            :component-table-item="LmsSuperadminWorkflowsListTableItem"
            :sort-queryable="sortQueryable"
            @emit-sort="handleSort"
        />
    </div>
</template>

<script>
import LmsSuperadminWorkflowsListTableItem from '@/components/lms/superadmin/workflows/list/LmsSuperadminWorkflowsListTableItem'
import ComponentTable from '@/components/default/shared/ComponentTable'

export default {
  name: 'lms-superadmin-workflows-list-table',
  components: {
    ComponentTable
  },
  data () {
    return {
      LmsSuperadminWorkflowsListTableItem
    }
  },
  props: {
    items: {
      type: [Array, Object]
    },
    sortQueryable: {
      type: Boolean
    }
  },
  computed: {
    tableLabels () {
      let labels = []

      labels = [
        {
          key: 'name',
          title: 'Name',
          type: 'string',
          sortable: false,
          queryable: false
        },
        {
          key: 'targetAudience',
          title: 'Target audience',
          type: 'string',
          sortable: false,
          queryable: false
        },
        {
          key: 'workflowTrigger',
          title: 'On complete of',
          type: 'string',
          sortable: false,
          queryable: false
        },
        {
          key: 'after',
          title: 'After',
          type: 'string',
          sortable: false,
          queryable: false
        },
        {
          key: 'enrolTo',
          title: 'Enrol to',
          type: 'string',
          sortable: false,
          queryable: false
        },
        {
          key: 'enabled',
          title: 'Status',
          type: 'string',
          sortable: false,
          queryable: false
        },
        {
          key: '',
          title: '',
          type: 'string',
          sortable: false,
          queryable: false
        }
      ]

      return labels
    }
  },
  methods: {
    handleSort (data) {
      this.$emit('emit-sort', data)
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/workflows/_workflowslisttable.scss";
</style>
